"use strict";

define('uikit/views/table.ellipsis',['underscore', './table.selected', '../elements/dropdown'], function (_, TableSelectedView, Dropdown) {
  var TableEllipsis = TableSelectedView.extend({
    options: _.extend({}, TableSelectedView.prototype.options, {
      collection: null
    }),
    ui: {
      icon: 'i.icon'
    },
    initialize: function initialize() {
      TableSelectedView.prototype.initialize.apply(this, arguments);
      this.view = new Dropdown({
        iconOnly: true,
        icon: 'ellipsis horizontal',
        pointing: 'left',
        mode: Dropdown.BUTTON_MODE,
        circular: true,
        bindings: this.bindings,
        inverted: this.inverted
      });
      this.childBindings.text = 'text';
      this.childBindings.icon = 'icon';
      this.childBindings.link = 'link';
      this.view.childBindings = this.childBindings;
      this.bindOption('collection', 'collection', this.view);
      this.setupContextMenu();
      this.view.on('press', function () {
        var args = _.toArray(arguments),
          row = this.getOption('rowView');
        this.triggerMethod.apply(this, ['action', this].concat(args));
        row.triggerMethod.apply(row, ['action'].concat(args));
      }, this);
    },
    onChangeCollection: function onChangeCollection() {
      this.view.collection = this.collection;
    },
    setupContextMenu: function setupContextMenu() {
      var row = this.getOption('rowView'),
        dropdown = this.view,
        self = this;
      function reposition(ev) {
        var dp = dropdown.$el,
          menu = dropdown.$el.find('.menu'),
          columnDp = dp.closest('td'),
          columnClicked = $(ev.target),
          table = columnClicked.closest('table'),
          topOffset = 2 * parseInt(columnClicked.css('font-size'));
        menu.css({
          top: ev.offsetY + columnClicked.offset().top - table.offset().top - columnClicked.closest('tr').position().top - topOffset,
          left: ev.offsetX + columnClicked.position().left - parseInt(columnDp.css('padding-left'))
        });
      }
      function setOriginalPosition() {
        dropdown.$el.find('.menu').css({
          top: '0%',
          left: '100%'
        });
      }
      dropdown.on('dropdown:hide', function () {
        setTimeout(function () {
          setOriginalPosition();
        }, 400);
      });
      dropdown.$el.on('mousedown', function (ev) {
        var menuEl = dropdown.$el.find('.menu').get(0);
        self._menuClick = false;
        if (!menuEl.contains(ev.target)) {
          setOriginalPosition();
        } else {
          self._menuClick = true;
        }
      });
      row.$el.on('contextmenu', function (ev) {
        var contextMenuEl = dropdown.$el,
          _contextMenu = window._contextMenu;
        if (_contextMenu && _contextMenu.get(0) != contextMenuEl.get(0)) {
          _contextMenu.dropdown('hide');
        }
        window._contextMenu = contextMenuEl;
        if (!self.visible || self.visible && self._menuClick) {
          self._menuClick = false;
          return;
        }
        row.$el.focus();
        reposition(ev);
        dropdown.$el.dropdown('show');
        return false;
      }).on('blur', function () {
        if (self._menuClick) {
          return;
        }
        dropdown.$el.dropdown('hide');
      });
    }
  });
  return TableEllipsis;
});

